import slideDel from './slideDel.vue'
export default slideDel


// WEBPACK FOOTER //
// ./src/components/slideDel/index.js